import React from 'react';
import { Title } from '../components';
import { tips } from '../data';
import Tip from './Tip';
const Tips = () => {
  return (
    <section className="section bg-green-200 text-center" id="tips">
      <div className="section-center">
        <Title title="travel tips" />
        <p className="mb-6 sm:text-lg md:text-2xl">
          Prepare for your trip with these practical articles
        </p>
        <div className="section-center pt-0">
          <div className="grid grid-cols-3 sm:grid-cols-5 gap-y-6 gap-x-2 sm:gap-x-6">
            {tips.map(tip => (
              <Tip key={tip.id} tip={tip} />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Tips;
